import {
  CREATING_NDA_TEMPLATE_REQUEST, CREATING_NDA_TEMPLATE_SUCCEDDED, CREATING_NDA_TEMPLATE_FAILED,

  UPDATING_NDA_TEMPLATE_REQUEST, UPDATING_NDA_TEMPLATE_SUCCEDDED, UPDATING_NDA_TEMPLATE_FAILED,

  FETCHING_NDA_TEMPLATE_REQUEST, FETCHING_NDA_TEMPLATE_SUCCEDDED, FETCHING_NDA_TEMPLATE_FAILED,

  FETCHING_ALL_NDA_TEMPLATE_REQUEST, FETCHING_ALL_NDA_TEMPLATE_SUCCEDDED, FETCHING_ALL_NDA_TEMPLATE_FAILED,

  DELETING_NDA_TEMPLATE_REQUEST, DELETING_NDA_TEMPLATE_SUCCEDDED, DELETING_NDA_TEMPLATE_FAILED

} from './actionTypes.jsx';


import axios from 'axios';
import buildUrl from 'build-url-ts';

const apiUrl=process.env.REACT_APP_API_URL;
const API_BASE_URL = `${apiUrl}/api/2.0`;
const NDA_TEMPLATE_URL = `${API_BASE_URL}/nda-templates`;

/**
 * Create NDA Template
 */
export function createNDATemplate(request) {
  return function (dispatch) {
    dispatch(creatingNDATemplateRequest());

    return axios({
    method: "POST",
    url: NDA_TEMPLATE_URL,
    data: request
    })
    .then(response => {
    return dispatch(creatingNDATemplateSucceeded(response.data));
    })
    .catch(error =>{
    return dispatch(creatingNDATemplateFailed(error));
    })
  }
}

function creatingNDATemplateRequest() {
  return {
      type: CREATING_NDA_TEMPLATE_REQUEST,
      payload: {}
  }
}

function creatingNDATemplateSucceeded(json) {
  return {
      type: CREATING_NDA_TEMPLATE_SUCCEDDED,
      payload: json
  }
}

function creatingNDATemplateFailed(error) {
  return {
      type: CREATING_NDA_TEMPLATE_FAILED,
      payload: error
  }
}

/**
 * Updating NDA Template
 */
export function updateNDATemplate(id, request) {
  return function(dispatch) {
    dispatch(updatingNDATemplateRequest(id));

    let url = buildUrl(NDA_TEMPLATE_URL, {
      path: `${id}`
    });

    return axios({
      method: "PUT",
      url: url,
      data: request
    })
    .then(response => {
      return dispatch(updatingNDATemplateSucceeded(response.data));
    })
    .catch(error => {
      return dispatch(updatingNDATemplateFailed(id, error));
    })
  }
}

function updatingNDATemplateRequest(id) {
  return {
    type: UPDATING_NDA_TEMPLATE_REQUEST,
    payload: id
  }
}

function updatingNDATemplateSucceeded(json) {
return {
  type: UPDATING_NDA_TEMPLATE_SUCCEDDED,
  payload: json
  }
}

function updatingNDATemplateFailed(id, error) {
  return {
    type: UPDATING_NDA_TEMPLATE_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}

/**
 * Fetching NDA Template
 */
export function fetchNDATemplate(id) {
  return function (dispatch) {
    dispatch(fetchingNDATemplateRequest(id));

    let url = buildUrl(NDA_TEMPLATE_URL, {
      path: `${id}`
    });

    return axios({
      method: "GET",
      url: url
    })
    .then(response => {
      return dispatch(fetchingNDATemplateSuccedded(id, response.data))
    })
    .catch(error => {
      return dispatch(fetchingNDATemplateFailed(id, error))
    })
  }
}

function fetchingNDATemplateRequest(id) {
  return {
    type: FETCHING_NDA_TEMPLATE_REQUEST,
    payload: id
  }
}

function fetchingNDATemplateSuccedded(id, json) {
  return {
    type: FETCHING_NDA_TEMPLATE_SUCCEDDED,
    payload: {
      id: id,
      response: json
    }
  }
}

function fetchingNDATemplateFailed(id, error) {
  return {
    type: FETCHING_NDA_TEMPLATE_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}

/**
 * Fetching NDA Template
 */
export function fetchAllNDATemplates() {
  return function(dispatch) {
    dispatch(fetchingAllNDATemplatesRequest());

    return axios({
      method: "GET",
      url: NDA_TEMPLATE_URL
    })
    .then(response => {
      return dispatch(fetchingAllNDATemplatesSuccedded(response.data));
    })
    .catch(error => {
      return dispatch(fetchingAllNDATemplatesFailed(error))
    })
  }
}

function fetchingAllNDATemplatesRequest() {
  return {
    type: FETCHING_ALL_NDA_TEMPLATE_REQUEST,
    payload: {}
  }
}

function fetchingAllNDATemplatesSuccedded(json) {
  return {
    type: FETCHING_ALL_NDA_TEMPLATE_SUCCEDDED,
    payload: json
  }
}

function fetchingAllNDATemplatesFailed(error) {
  console.log(error);
  return {
    type: FETCHING_ALL_NDA_TEMPLATE_FAILED,
    payload: error
  }
}

/**
 * Delete NDA Template
 */
export function deleteNDATemplate(id) {
  return function(dispatch) {
    dispatch(deletingNDATemplateRequest(id));

    let url = buildUrl(NDA_TEMPLATE_URL, {
      path: `${id}`
    });

    return axios({
      method: "DELETE",
      url: url
    })
    .then(response => {
      return dispatch(deletingNDATemplateSuccedded(id, response.data));
    })
    .catch(error => {
      return dispatch(deletingNDATemplatefailed(id, error));
    })
  }
}

function deletingNDATemplateRequest(id) {
  return {
    type: DELETING_NDA_TEMPLATE_REQUEST,
    payload: id
  }
}

function deletingNDATemplateSuccedded(id, json) {
  return {
    type: DELETING_NDA_TEMPLATE_SUCCEDDED,
    payload: {
      id: id,
      resposne: json
    }
  }
}

function deletingNDATemplatefailed(id, error) {
  return {
    type: DELETING_NDA_TEMPLATE_FAILED,
    payload: {
      id: id, 
      error: error
    }
  }
}